import { requestAnimationFramePromise } from "@shared/requestanimationframepromise";
import { transitionend } from "@front/dom";
import { popupPane } from "./popuppane";

const lang = {
  en: {
    days: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
    months: ['January','February','March','April','May','June','July','August','September','October','November','December']
  }
};


type DatepickerOptions = {
  containerClass: string,
  weekClass: string,
  dayClass: string,
  activeClass: string,
  inactiveClass: string,
  headerClass: string,
  monthClass: string,
  range: boolean,
  prefix: string,
  defaultStart: string,
  defaultEnd: string,
  language: string,
  startDayOffset?: number,
  onSelect?: (...a: any) => any
}


export class Datepicker {

  options: DatepickerOptions;
  container: HTMLElement;
  input1: HTMLInputElement;
  input2: HTMLInputElement;
  clicker: HTMLElement;
  $input1: JQuery;
  $input2: JQuery;
  $clicker: JQuery;
  $picker: JQuery;
  click: number;
  values: [Date, Date];

  visibleYear: number;
  visibleMonth: number;
  $visibleMonth: JQuery;
  _isopen: boolean;

  constructor(options: DatepickerOptions, container: HTMLElement, input1?: HTMLInputElement, input2?: HTMLInputElement, clicker?: HTMLElement);
  constructor(container: HTMLElement, input1: HTMLInputElement, input2?: HTMLInputElement, clicker?: HTMLElement);
  constructor() {
    let i=0;
    let options: DatepickerOptions;
    let input1: HTMLInputElement;
    let input2: HTMLInputElement;
    let clicker: HTMLElement;

    if (typeof(arguments[i]) === 'object' && !(arguments[i] instanceof HTMLElement)) {
      options = arguments[i++];
    }
    let container = arguments[i++];
    if (arguments[i] instanceof HTMLInputElement) {
      input1 = arguments[i++];
    }
    if (arguments[i] instanceof HTMLInputElement) {
      input2 = arguments[i++];
    }
    if (arguments[i] instanceof HTMLElement) {
      clicker = arguments[i++];
    }

    let that = this;
    this.options = options = $.extend({
      prefix: '_datePick',
      containerClass: '_dateContainer',
      monthClass: '_dateMonth',
      weekClass: '_dateWeek',
      dayClass: '_dateDay',
      inactiveClass: '_dateInactive',
      activeClass: '_dateActive',
      headerClass: '_dateHeader',
      language: 'en',
      range: false,
      startDayOffset: 1	// Start week on mondays, not sunday
    }, options);


    if (!input1 && clicker instanceof HTMLInputElement) {
      clicker;
    }
    if (!input1) {
      return;
    }
    if (!clicker) {
      clicker = input1;
    }

    this.container = container;
    this.input1 = input1;
    this.input2 = input2;
    this.clicker = clicker;
    this.$input1 = $(input1);
    this.$input2 = $(input2);
    this.$clicker = $(clicker);
    
    this.values = [
      this.parseDate(input1 ? input1.value: undefined),
      this.parseDate(input2 ? input2.value: undefined)
    ];
    this.click = 0;

    // Create container
    let $picker = this.$picker = $('<div></div>').addClass( this.options.containerClass );

    // For range-selects, we need an Cancel / OK button
    if (options.range) {
      let $returnArea = $('<div></div>').addClass( this.options.prefix + '_returnArea' );
      let $cancel = $('<span></span>');
      $cancel.addClass(options.prefix + '_button');
      $cancel.addClass(options.prefix + '_cancel');
      $cancel.text('Cancel');
      let $select = $('<span></span>');
      $cancel.addClass(options.prefix + '_button');
      $cancel.addClass(options.prefix + '_select');
      $cancel.text('Select');
      $returnArea.append($cancel).append($select);
      if (options.defaultStart && options.defaultEnd) {
        let $reset = $('<span></span>');
        $reset.addClass(options.prefix + '_reset');
        $reset.text('Reset');
        $returnArea.append($reset);
      }
      $picker.append($returnArea);
    }

    // Create month-label and next/previous buttons
    let $navigation = $('<div/>').addClass(options.prefix + '_navigation');
    let $label = $('<div/>').addClass(options.prefix + '_label');
    $label.append( $('<span/>').addClass(options.prefix + '_month') );
    $label.append( $('<span>&nbsp;</span>') );
    $label.append( $('<span/>').addClass(options.prefix + '_year') );
    $navigation.append( $('<div/>').addClass(options.prefix + '_browsePrev') );
    $navigation.append( $label );
    $navigation.append( $('<div/>').addClass(options.prefix + '_browseNext') );
    $picker.append( $navigation );
    $navigation.on('click', '.' + options.prefix + '_browsePrev', () => {
      this.skipMonth(-1);
    });
    $navigation.on('click', '.' + options.prefix + '_browseNext', () => {
      this.skipMonth(1);
    });
    $navigation.on('selectstart', false);
    
    // Create container for months
    let $months = $('<div></div>').addClass( options.prefix + '_months' ).css('position', 'relative');
    $picker.append($months);
    
    // Delay one tick, don't catch current click
    setTimeout(() => {
      $picker.on('click', '.' + options.prefix + '_cancel' ,(e) => {
        if (e.which !== 1) {
          return;
        }
        this.close();
      });
      $picker.on('click', '.' + options.prefix + '_select', (e) => {
        if (e.which !== 1) {
          return;
        }
        this.select();
        this.close();
      });
      $picker.on('click', '.' + options.prefix + '_reset', () => {
        this.values[0] = this.parseDate(options.defaultStart);
        this.values[1] = this.parseDate(options.defaultEnd);
        this.select();
      });
    }, 0);
    
    let click = 0;
    $picker.on('click', '.' + options.dayClass, function(e) {
      if (e.which !== 1) {
        return;
      }
      
      let $day = $(this);
      let dateObject = that.parseDate($day.data('year'), $day.data('month'), $day.data('date'));
      let values = that.values;

      // Select single date, close calendar on select
      if (!that.options.range) {
        values[0] = dateObject;
        values[1] = undefined;
        that.select();
        that.close();
      }
            
      // Range selector. Two types of click, start and end
      else {
        // First click
        if (click++ % 2 === 0) {
          values[0] = dateObject;
          values[1] = undefined;
          $picker.on('hover.daterangemark', function() {
            let $day = $(this);
            let dateObject = that.parseDate($day.data('year'), $day.data('month'), $day.data('date'));
            that.mark(values[0], dateObject);
          });
        }
        // Second click
        else {
          values[1] = dateObject;
          // Switch order if highest date was selected first
          if (values[0] > values[1]) {
            let temp = values[1];
            values[1] = values[0];
            values[0] = temp;
          }
          $picker.off('hover.daterangemark');
        }
        that.mark(values[0], values[1], true);
      }
    });


    clicker.addEventListener('click', () => {
      this.popup();
    });
    //clicker.addEventListener('blur', () => {
    //  this.close();
    //});
  }


  popup() {
    // Show current month
    this.show();
    popupPane(this.$picker[0], this.container, this.clicker);
  }


  renderMonth(year: number, month: number) {
    let that = this;
    
    // Get first day of month
    let date = new Date(Date.UTC(year, month, 1));
    let days = new Date(Date.UTC(year, month, 0)).getUTCDate();

    // Subtract days from previous month that are in first week
    let offset = ( ( 1 - date.getUTCDay() +1 ) -7) % 7;
    date.setDate(offset);

    // Add day-header
    let $header = $('<div>').addClass( this.options.headerClass ).addClass( this.options.weekClass );
    for (let i=this.options.startDayOffset; i<7+this.options.startDayOffset; i++) {
      let $day = $('<span/>');
      $day.addClass( this.options.dayClass );
      $day.addClass( this.options.prefix + '_col_' + (i-this.options.startDayOffset) );
      $day.text( lang[ this.options.language ].days[i%7].substring(0,3) )
      $header.append($day);
    }

    let $month = $('<div/>');
    $month.addClass(this.options.monthClass);
    $month.addClass(this.options.prefix + '_year_' + year);
    $month.addClass(this.options.prefix + '_month_' + month);
    $month.append($header);

    // A container for all days
    let $dayContainer = $('<div class="' + this.options.prefix + '_dayContainer"/>');
    $month.append($dayContainer);
    
    // Keep today
    let nowUTC = new Date();
    let today = new Date(Date.UTC(nowUTC.getFullYear(), nowUTC.getMonth(), nowUTC.getDate()));
    
    // Check if we need to display 5 or 6 weeks
    let limit = (days-offset >= 35) ? 42 : 35;
    
    // Loop all weeks we should render
    let $week: JQuery;
    for (let i=0; i<limit; i++) {
      // Create day-element
      let $day = $('<span></span>');
      $day.addClass(this.options.dayClass);
      $day.addClass(this.options.prefix + '_col_' + i%7); 
      if (month > date.getUTCMonth() || month < date.getUTCMonth()) {
        $day.addClass(this.options.inactiveClass);
      }
      $day.text(date.getUTCDate());

      if (!$week) {
        $week = $('<div></div>');
        $week.addClass(this.options.weekClass);
      }
      $week.append($day);
      if (i%7 == 6) {
        $dayContainer.append($week);
        $week = undefined; 
      }

      // Add date classes 
      $day.addClass(this.options.prefix + '_year_' + date.getUTCFullYear());
      $day.addClass(this.options.prefix + '_month_' + (date.getUTCMonth()+1));
      $day.addClass(this.options.prefix + '_date_' + date.getUTCDate());
      
      $day.data('year', date.getUTCFullYear());
      $day.data('month', date.getUTCMonth()+1);
      $day.data('date', date.getUTCDate());

      if (date.getUTCFullYear() === today.getUTCFullYear() && date.getUTCMonth() === today.getUTCMonth() && date.getUTCDate() === today.getUTCDate()) {
        $day.addClass(that.options.prefix + '_today');
      }

      // Increment one day
      date.setUTCDate(date.getUTCDate() + 1);
    }

    return $month;
  }


  parseDate(year: number, month: number, day: number): Date;
  parseDate(dateString: string): Date;
  parseDate(date: Date): Date;
  parseDate(a, b?, c?) {
    let date: Date;

    if (!a!) {
      date = null;
    } else if (a instanceof Date) {
      date = a;
    } else if (typeof(a) === 'string') {
      let array = (/(\d\d\d\d)-(\d\d)-(\d\d)/).exec(a);
      if (array) {
        date = new Date(Date.UTC(parseInt(array[1], 10), parseInt(array[2], 10)-1, parseInt(array[3], 10)));
      } else {
        date = null;
      }
    } else if (typeof(a) === 'number') {
      date = new Date(Date.UTC(a, b-1, c));
    }
    
    return date;
  }


  mark(date1?: Date, date2?: Date, selected?: boolean) {
    let that = this;
    let dates: Date[] = [];
    if (date1) {
      dates.push(date1);
    }
    if (date2) {
      dates.push(date2);
    }
    
    // Clear previous range
    this.$picker.find('.' + this.options.prefix + '_range').removeClass(this.options.prefix + '_range');
    this.$picker.find('.' + this.options.prefix + '_marked').removeClass(this.options.prefix + '_marked');

    // Add _marked to start and optionally stop date
    for (const date of dates) {
      if (selected) {
        that.$picker.find(
          '.' + that.options.prefix + '_year_' + date.getUTCFullYear() +
          '.' + that.options.prefix + '_month_' + (date.getUTCMonth()+1) +
          '.' + that.options.prefix + '_date_' + date.getUTCDate() 
        ).addClass(that.options.prefix + '_marked');
      }
    }

    // No range if only one date is given
    if (dates.length <= 1) {
      return;
    }

    let max = (dates[0] > dates[1]) ? dates[0] : dates[1];
    let min = (dates[0] < dates[1]) ? dates[0] : dates[1];
    let minYear = min.getUTCFullYear();
    let maxYear = max.getUTCFullYear();
    let minMonth = min.getUTCMonth()+1;
    let maxMonth = max.getUTCMonth()+1;
    let minDate = min.getUTCDate();
    let maxDate = max.getUTCDate();

    // Loop all dates between the selected ones to mark them
    for (let i=minYear; i<=maxYear; i++) {
      // Start from start-month if this is first year, if not, start from january
      let j = (i > minYear) ? 1 : minMonth;
      // End at last month if this is last year, if not, end december
      let maxj = (i < maxYear) ? 12 : maxMonth;
      for (; j<=maxj; j++) {
        let k = (j > minMonth || i > minYear) ? 1 : minDate;
        let maxk = (j < maxMonth || i < maxYear) ? 31 : maxDate;
        for (; k<=maxk; k++) {
          let selector = 
            '.' + this.options.prefix + '_year_' + i +
            '.' + this.options.prefix + '_month_' + j +
            '.' + this.options.prefix + '_date_' + k;
          this.$picker.find(selector).addClass( this.options.prefix + '_range' );
        }
      }
    }
  }


  async show(date?: Date) {
    let that = this;
    let active = this.getActive();

    // If date isn't given, use active date or today
    if (!date) {
      date = active;
    }
    if (!date) {
      date = new Date(); // Date in UTC
      date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())); // Set in UTC, based on user's location
    }
    
    // "Shortcuts"
    let year = date.getUTCFullYear();
    let month = date.getUTCMonth();
    let $months = this.$picker.find('.' + this.options.prefix + '_months');

    let $month;
    // Render one month before and one after, since some days might be selectable from those months
    $.each([-1,0,1], function(key, i) {
      let lmonth = (((month+i)%12)+12)%12;
      let lyear = year + Math.floor( (month+i) / 12 );
      
      // Check if queried month is already rendered 
      let monthSelector = 
        '.' + that.options.monthClass + 
        '.' + that.options.prefix + '_year_' + lyear +
        '.' + that.options.prefix + '_month_' + lmonth;
      let $lmonth = that.$picker.find( monthSelector );

      // If not, render it
      if ($lmonth.length <= 0) {
        $lmonth = that.renderMonth(lyear, lmonth);
        $lmonth.css('display', 'none');
        $months.append( $lmonth );
      }

      // Check if this is current
      if (i === 0) $month = $lmonth;
    });

    // Display immediately if no month is shown
    if (!that.$visibleMonth) {
      // Update selected days
      that.values[0] = that.values[0] || that.parseDate(that.input1.value);
      that.values[1] = that.values[1] || that.input2 ? that.parseDate(that.input2.value) : undefined;

      // Mark selected range
      that.mark(that.values[0], that.values[1], true);
      $month.css('display', 'block');
    }
    // We're already at correct month
    else if ($month[0] === that.$visibleMonth[0]) {
      return;
    }
    // Show switch-effect if we're currently displaying another month
    else {
      // 
      $months.css({
        width: '100%',
        height: $months.height(),
        overflow: 'hidden'
      });

      //Forward
      let back = true;
      if (year > that.visibleYear || year === that.visibleYear && month > that.visibleMonth) {
        back = false;
      }

      // Move new month
      $month.stop();
      $month.css({
        position: 'absolute',	
        transform: 'translateX(' + (back ? '-100%' : '100%') + ')',
        transition: 'transform 0s',
        width: '100%',
        display: ''
      });

      // Move old month
      that.$visibleMonth.stop();
      that.$visibleMonth.css({
        position: 'absolute',
        transform: 'translateX(0)',
        transition: 'transform 0s',
        width: '100%'
      });

      await requestAnimationFramePromise();
      $month.css({
        transform: 'translateX(0)',
        transition: 'transform .4s'
      });
      that.$visibleMonth.css({
        transform: 'translateX(' + (back ? '100%' : '-100%') + ')',
        transition: 'transform .4s'
      });
      $months.css({
        height: $month.height(),
        transition: 'height .4s'
      });


      await transitionend($months[0]);
      $month.css({
        transform: '',
        transition: '',
        position: '',
        width: ''
      });
      that.$visibleMonth.css({
        position: '',
        transform: '',
        transition: '',
        display: 'none',
        width: ''
      });
      $months.css({
        height: ''
      });
    }


    // Update text-label
    let $yearLabel = that.$picker.find('.' + that.options.prefix + '_label .' + that.options.prefix + '_year');
    let $monthLabel = that.$picker.find('.' + that.options.prefix + '_label .' + that.options.prefix + '_month');
    $yearLabel.text( year );
    $monthLabel.text( lang[ that.options.language ].months[ month ] );

    // Set current month
    that.visibleMonth = month;
    that.visibleYear = year;
    that.$visibleMonth = $month;
    
    that.$input1.trigger('focus');
    
    // Mark textarea as open
    that.$clicker.addClass(that.options.prefix + '_open');
  }


  skipMonth(offset: number) {
    if (typeof(this.visibleMonth) === 'undefined') {
      return this.show();
    }

    let yearsOff = Math.floor((this.visibleMonth+offset)/12);
    let monthsOff = (offset+12) % 12;
    let date = new Date(Date.UTC(this.visibleYear + yearsOff, (this.visibleMonth + monthsOff) % 12, 1));

    return this.show(date);
  }

  
  close() {
    this.$picker.trigger('close');
  }


  format(date: Date) {
    if (!date) {
      return '';
    } else {
      let year = date.getUTCFullYear();
      let month = date.getUTCMonth()+1;
      let day = date.getUTCDate();
      let yearStr = year.toString();
      let monthStr = ('0' + month).substr(-2);
      let dayStr = ('0' + day).substr(-2);
      return yearStr + '-' + monthStr + '-' + dayStr;
    }
  }


  select() {
    if (typeof(this.values[0]) !== 'undefined' && this.input1 && this.values[0]) {
      this.$input1.val(this.format(this.values[0])).trigger('change');
    }
    if (!this.values[1]) this.values[1] = this.values[0];
    if (this.input2 && this.values[1]) {
      this.$input2.val(this.format(this.values[1])).trigger('change');
    }

    // Mark as selected
    if (this.input1.value != this.options.defaultStart || this.input2.value != this.options.defaultEnd) {
      this.$clicker.addClass('_selected');
    } else {
      this.$clicker.removeClass('_selected');
    }

    this.mark(this.values[0], this.values[1], true);

    if (typeof(this.options.onSelect) === 'function') {
      this.options.onSelect();
    }
    
    this.$input1.trigger('blur');
    this.$input2.trigger('blur');
  }


  getActive(input = this.input1) {
    let date = this.parseDate(input.value);
    return date;
  }
};


